"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.WEB_ATTESTATION_HEADER = void 0;
var metrics_utils_1 = require("@snapchat/metrics-utils");
var computeWebAttestation_1 = __importDefault(require("./computeWebAttestation"));
exports.WEB_ATTESTATION_HEADER = 'X-Snapchat-Web-Client-Auth';
var WebAuthenticator = (function (_super) {
    __extends(WebAuthenticator, _super);
    function WebAuthenticator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WebAuthenticator.prototype.authRequest = function (authType, payload, headers) {
        var _a;
        switch (authType) {
            case metrics_utils_1.AuthType.None: {
                return Promise.resolve(headers);
            }
            case metrics_utils_1.AuthType.WebAttestation: {
                var webAttestationHeaderBase64 = computeWebAttestation_1["default"](payload);
                return Promise.resolve(__assign(__assign({}, headers), (_a = {}, _a[exports.WEB_ATTESTATION_HEADER] = webAttestationHeaderBase64, _a)));
            }
            default: {
                return Promise.reject("Unsupported auth type: " + authType);
            }
        }
    };
    return WebAuthenticator;
}(metrics_utils_1.Authenticator));
exports["default"] = WebAuthenticator;
//# sourceMappingURL=WebAuthenticator.js.map